module.exports = __webpack_public_path__ + "static/flags/KP-801d2e332458158efc80073384261363.gif";